export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/search-6c7ba72d16bf6ba0806f4a02f9a0c069.svg";